import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const authApi = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api/auth' : 'http://localhost:8000/api/auth'
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const res = await authApi.get('/me', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(res.data.user);
    } catch (e) {
      console.error(e);
      setToken(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchUser();
    } else {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      setUser(null);
      setLoading(false);
    }
  }, [token, fetchUser]);

  const login = async (phone, pin) => {
    const res = await authApi.post('/login', { phone, pin });
    setToken(res.data.token);
    setUser(res.data.user);
    // Clear any stale cached data from a previous session
    localStorage.removeItem('finance_months_cache');
  };

  const register = async (phone, pin) => {
    await authApi.post('/register', { phone, pin });
    await login(phone, pin);
  };

  const logout = () => {
    setToken(null);
  };

  const value = {
    user,
    token,
    loading,
    login,
    register,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
